import React, { forwardRef, memo } from 'react';
import cn from 'classnames';

import { noop } from '@/utils';

type InputType = 'email' | 'text' | 'textarea';

interface InputTextBaseProps {
  className?: string;
  type?: InputType;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

type InputTextProps =
  InputTextBaseProps
  & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'>
  & Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'type' | 'onChange'>;

const InputText = forwardRef<HTMLInputElement | HTMLTextAreaElement, InputTextProps>(({
  className = undefined,
  type = 'text',
  onChange = noop,
  ...props
}, ref) => {
  if (type === 'textarea') {
    return (
      <textarea
        ref={ref as React.Ref<HTMLTextAreaElement>}
        className={cn('form-input', className)}
        onChange={onChange as React.ChangeEventHandler<HTMLTextAreaElement>}
        {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
      />
    );
  }

  return (
    <input
      ref={ref as React.Ref<HTMLInputElement>}
      className={cn('form-input', className)}
      type={type}
      onChange={onChange as React.ChangeEventHandler<HTMLInputElement>}
      {...(props as React.InputHTMLAttributes<HTMLInputElement>)}
    />
  );
});

export default memo(InputText);
